import { useEffect } from 'react'
import { useConnect } from 'sb-redux-hook'
import config from 'app-config'


const isTestApi = config.api === 'test'
const isDevApi  = config.env === 'development'
const isTest    = isTestApi || isDevApi


const useAccess = () => {
  const { layers, pathname } = useConnect({
    layers: 'me.layers',
    pathname: 'routing.locationBeforeTransitions.pathname',
  })

  const hasAccess = typeof layers === 'object' && Object.keys(layers).some((key) => (
    typeof layers[key] === 'object'
    && layers[key].link
    && (
      pathname.includes(layers[key].link)
      || layers[key].link.includes(pathname)
    )
  ))

  useEffect(() => {
    if (layers && !hasAccess && !isTest) {
      window.location.href = '/'
    }
  }, [ layers, hasAccess ])

  return hasAccess || isTest
}


export default useAccess
